<template>
    <div v-if="hasErrors" class="mr-3 validation-errors">
        <v-tooltip text="Import Line Errors" location="bottom">
            <template v-slot:activator="{ props }">
                <v-badge @click="showErrors" :content="totalErrors">
                    <v-icon icon="mdi-alert-circle" v-bind="props" class="text-orange-lighten-2"></v-icon>
                </v-badge>
            </template>
        </v-tooltip>
        <v-dialog v-model="errorModal"
                  persistent
                  :scrim="false">
            <v-card>
                <v-toolbar dark
                           color="primary">
                    <v-spacer></v-spacer>
                    <v-btn icon
                           dark
                           @click="errorModal = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <p>The following imported lines have validation errors. Review and remove each error when resolved.</p>
                    <v-table>
                        <thead>
                            <tr>
                                <th class="text-left">Job</th>
                                <th class="text-left">Customer</th>
                                <th class="text-left">Description</th>
                                <th class="text-left">Qty</th>
                                <th class="text-left">Error</th>
                                <th class="text-right"></th>
                            </tr>
                        </thead>
                        <tbody v-for="job in jobs" :key="job.id">
                            <tr class="job-header-row bg-grey-lighten-4">
                                <td>
                                    <router-link :to="'/'+$constants.entities.Job.ROUTE+job.id" @click="errorModal=false">
                                        {{ job.name }}
                                    </router-link>
                                </td>
                                <td>{{ job.contact?.name }}</td>
                                <td colspan="4"></td>
                            </tr>
                            <tr v-for="item in job.jobItems" :key="item.id">
                                <td></td>
                                <td></td>
                                <td>{{ item.description }}</td>
                                <td>{{ item.quantity }}</td>
                                <td>{{ getValidationErrorTitle(item.validationError) }}</td>
                                <td class="text-right">
                                    <v-btn size="small" :loading="item.removing" color="warning"
                                           @click="removeError(job, item)">Remove</v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </v-table>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<style scoped>
    .validation-errors {
        cursor: pointer;
    }
    .job-header-row td {
        font-weight: 500;
    }
</style>
<script>
    import { mapActions } from "vuex";
    import jobs from "../constants/modules/jobs";
    function initialState() {
        return {
            loading: false,
            jobs: [],
            errorModal: false,
            refreshInterval: null
        };
    }
    export default {
        name: "ImportLineValidations",
        data: function () {
            return initialState();
        },
        mounted: function () {
            this.loadData();
            this.refreshInterval = setInterval(() => {
                this.loadData();
            }, 600000);
        },
        beforeUnmount: function () {
            if (this.refreshInterval) {
                clearInterval(this.refreshInterval);
            }
        },
        methods: {
            ...mapActions([
                "showErrorSnack",
                "showSuccessSnack"
            ]),
            showErrors() {
                this.errorModal = true;
            },
            reset: function () {
                Object.assign(this.$data, initialState());
            },
            loadData() {
                this.loading = true;
                this.$api.get('jobs/validationerrors')
                    .then(res => {
                        this.jobs = res.data;
                        this.loading = false;
                    }).catch(() => {
                        this.loading = false;
                    });
            },
            getValidationErrorTitle(code) {
                const err = jobs.validationErrors.find(e => e.id === code);
                return err ? err.title : `Error ${code}`;
            },
            removeError(job, item) {
                item.removing = true;
                this.$api.post('jobs/removevalidationerror?jobItemId=' + item.id)
                    .then(() => {
                        item.removing = false;
                        job.jobItems = job.jobItems.filter(i => i.id !== item.id);
                        if (!job.jobItems.length) {
                            this.jobs = this.jobs.filter(j => j.id !== job.id);
                        }
                    }).catch(() => {
                        item.removing = false;
                        this.showErrorSnack("Whoops. We ran into an error.");
                    });
            }
        },
        computed: {
            totalErrors() {
                return this.jobs.reduce((sum, job) => sum + (job.jobItems?.length || 0), 0);
            },
            hasErrors() {
                return this.totalErrors > 0;
            }
        }
    };
</script>
